import { render, staticRenderFns } from "./updateJob.vue?vue&type=template&id=510febd0&scoped=true&"
import script from "./updateJob.vue?vue&type=script&lang=js&"
export * from "./updateJob.vue?vue&type=script&lang=js&"
import style0 from "./updateJob.vue?vue&type=style&index=0&id=510febd0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510febd0",
  null
  
)

export default component.exports